import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    get_student_category,
  add_student_category,
  update_student_category,
  delete_student_category,
  get_student_category_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  studentCategorys: [],
  studentcategorylist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description:""
  },
};

// Async Thunks for API Calls
export const fetchstudentcategorylist = createAsyncThunk(
    'student_category/fetchstudent_categorylist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_student_category_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchstudent_category = createAsyncThunk(
  "student_category/fetchstudent_category",
  async ({ page, page_size,filter_fields,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_student_category(page, page_size,filter_fields,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createstudent_category = createAsyncThunk(
  "student_category/createstudent_category",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_student_category(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatestudent_category = createAsyncThunk(
  "student_category/updatestudent_category",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_student_category(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletestudent_category = createAsyncThunk(
  "student_category/deletestudent_category",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_student_category({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// student_category Slice
const studencategorySlice = createSlice({
  name: 'studencategorys',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, name,description } = action.payload;
      state.formData = { id, name,description };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description:""
      };
    },
    setStudentCategory(state, action) {
      state.studentCategorys = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchstudentcategorylist.fulfilled, (state, action) => {
        state.studentcategorylist = action.payload.data;
      })
       // Fetch student_category
       .addCase(fetchstudent_category.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchstudent_category.fulfilled, (state, action) => {
        state.loading = false;
        state.studentCategorys = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchstudent_category.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add student_category
      .addCase(createstudent_category.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createstudent_category.fulfilled, (state, action) => {
        state.addLoading = false;
        state.studentCategorys = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createstudent_category.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
        state.IsEditing = false;
      })
      // Update student_category
      .addCase(updatestudent_category.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatestudent_category.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatestudent_category.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete student_category
      .addCase(deletestudent_category.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletestudent_category.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletestudent_category.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setStudentCategory,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = studencategorySlice.actions;
export default studencategorySlice.reducer;
